var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMediaIconLinkedInNobg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.75 84.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.75,84.02h-18.86v-31.69c-.39-6.76-3.23-12.05-10.85-11.28-4.81.49-8.88,5.43-8.88,10.19v32.78h-18.86V27.23h18.86v7.89l3.39-4.17c15.62-11.72,33.98-2.34,35.2,17v36.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.14,
    y: 27.23,
    width: 18.86,
    height: 56.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.75,16.85C.64,14.78-.18,11.82.03,8.91.82-2.04,18.15-3.28,20.94,7.32c2.83,10.78-11.22,16.36-18.19,9.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaIconLinkedInNobg);
export default __webpack_public_path__ + "static/media/Social_Media_Icon_LinkedIn_nobg.d414c04cb967813761e0f7d596fc007e.svg";
export { ForwardRef as ReactComponent };